module.exports = __webpack_public_path__ + "static/media/FRAX-QUICK.b9fa139a.png";